module.exports = {"540234100":"宗嘎镇","540234101":"吉隆镇","540234200":"折巴乡","540234201":"贡当乡","540234202":"差那乡","540234203":"萨勒乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540234.json
// module id = 2505
// module chunks = 0